<template>
  <vs-dropdown
    vs-trigger-click
    class="cursor-pointer flex items-center">
    <vs-icon icon-pack="material-icons" icon="history" size="20px" class="cursor-pointer"/>
    <!-- <feather-icon
      icon="ClockIcon"
      class="cursor-pointer"
      svg-classes="w-6 h-6" />-->

    <vs-dropdown-menu class="history-dropdown">
      <vs-dropdown-item
        v-for="(item, index) in previousPages"
        :key="index"
        :to="item.fullPath">
        {{ $tc(item.title, item.i18n || 2) }}
      </vs-dropdown-item>

      <vs-dropdown-item v-if="!previousPages.length">
        No recent pages
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NavigationHistory',
  computed: {
    ...mapState(['navigationHistory']),
    previousPages() {
      return this.navigationHistory.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.history-dropdown {
  min-width: 200px;
}

</style>
